module.exports = __webpack_public_path__ + "components/flag/static/square/cv-e9d993ab6bc66095d2d10dcf3ced0cb2.svg";